export enum NewFriendSouce {
    PHONE = 'phone',
    EMAIL = 'email',
    CODE = 'code', //二维码
    CARD = 'card', // 名片
}

export enum NewFriendStatus {
    PASS = 'pass', // 通过
    REFUSE = 'refuse' //拒绝
}

// 用户信息
// UserId          int64  `json:"uid" bson:"_id"`                         // uid
// Name            string `json:"name" bson:"name"`                       // 名称
// NamePinYin      string `bson:"namePY" json:"namePY"`                   // 名称 拼音
// NamePinYinShort string `bson:"namePYS" json:"namePYS"`                 // 名称 拼音首字母
// Telno           string `json:"telno,omitempty" bson:"telno"`           // 手机号
// Email           string `json:"email,omitempty" bson:"email"`           // 邮箱
// Position        string `json:"position,omitempty" bson:"position"`     // 职位 "超级管理员"
// EmployeeID      string `json:"employeeID,omitempty" bson:"employeeID"` // 工号
// Appkey          string `json:"appkey" bson:"appkey"`                   // 应用 关联到具体某个公司
// MainAppkey      string `json:"mainAppkey" bson:"mainAppkey"`           // 主应用 多个公司
// Avatar          string `json:"avatar" bson:"avatar"`                   // 头像
// Passwd          string `json:"-" bson:"passwd"`                        // 密码
// CTime           int64  `json:"-" bson:"ctime"`                         // 创建时间
export interface UserSchema {
    uid: number;
    name?: string;
    namePY?: string;
    namePYS?: string;
    telno?: string;
    email?: string;
    position?: string;
    employeeID?: string;
    employee?: string;
    appkey?: string;
    mainAppkey?: string;
    avatar?: string;
    isFriend?: boolean;
    status?: string
    isColleague?: boolean;
    remark?: string; //昵称
    nick?: string; //昵称
    sex?: string;//"0"-女，"1"-男，"2"-未知
    birth?: string;
    privacy?: string;//是否公开账号，1-不公开账号，其余都是公开账号
    rtel?: string;     //备注手机号码
    rtelCheck?: string; //手机号码是否验证，"1"-验证，其余未验证
    remail?: string;   //备注邮箱
    remailCheck?: string;//邮箱是否验证，"1"-验证，其余未验证
    qrcode?: string;//个人二维码
    qrcode_desc?: string;//个人二维码描述
}

export const USER_LIST = 'UserList';
export type USER_LIST = typeof USER_LIST;
export const UserList = {
    name: USER_LIST,
    properties: {
        uid: 'int',
        name: 'string',
        namePY: 'string?',
        namePYS: 'string?',
        telno: 'string?',
        email: 'string?',
        position: 'string?',
        employeeID: 'string?',
        appkey: 'string',
        mainAppkey: 'string',
        avatar: 'string?',
        isFriend: { type: 'bool', default: false },
        isColleague: { type: 'bool', default: false },
        remark: 'string?',
        nick: 'string?',
        rtel: 'string?',
        rtelCheck: 'string?',
        remail: 'string?',
        remailCheck: 'string?',
    },
    primaryKey: 'uid',
};
// 好友
// Id           string `bson:"_id" json:"id"`              // 主uid：好友uid拼接
//  UserId       int64  `bson:"uid" json:"uid"`             // 我的uid
//  FriendUserId int64  `bson:"fuid" json:"fuid"`           // 好友的uid
//  Scene        string `bson:"scene" json:"scene"`         // 来源
//  Hello        string `bson:"hello" json:"hello"`         // 打招呼信息
//  ApplyUid     int64  `bson:"applyUid" json:"applyUid"`   // 申请人
//  ApplyTime    int64  `bson:"applyTime" json:"applyTime"` // 好友申请时间
//  AddedTime    int64  `bson:"addedTime" json:"addedTime"` // 好友添加时间
//  Flag         int32  `bson:"flag" json:"flag"`           // 标识位 0 - 有效 1 - 已删除
//  UpdateTime   int64  `bson:"utime" json:"utime"`         // 本记录更新的时间
//  CreateTime   int64  `bson:"ctime" json:"ctime"`         // 本记录创建时间
export interface FriendSchema {
    id: string;
    uid?: number; // 我的uid
    friendUid: number;
    scene?: string;
    hello: string;
    applyUid: number;
    applyTime: number;
    addedTime: number;
    flag: number; // 0: 有效， 1：已删除
    utime: number;
    ctime: number;
}

export const FRIEND_LIST = 'FriendList';
export type FRIEND_LIST = typeof FRIEND_LIST;
export const FriendList = {
    name: FRIEND_LIST,
    properties: {
        id: 'string',
        uid: 'int?', // 我的uid
        friendUid: 'int',
        scene: 'string?',
        hello: 'string',
        applyUid: 'int',
        applyTime: 'int',
        addedTime: 'int',
        flag: 'int', // 0: 有效， 1：已删除
        utime: 'int',
        ctime: 'int',
    },
    primaryKey: 'id',
};

// 好友申请
// Id         string `bson:"_id" json:"-"`                 // id由被申请人:申请人拼接 而成，被申请人在前方便二次处理
// ToUid      int64  `bson:"touid" json:"-"`               // 被申请人
// ApplyUid   int64  `bson:"applyUid" json:"applyUid"`     // 申请人
// Hello      string `bson:"hello" json:"hello"`           // 打招呼
// Scene      string `bson:"scene" json:"scene"`           // 来源 加好友的场景
// ApplyTime  int64  `bson:"applyTime" json:"applyTime"`   // 申请时间 单位毫秒  前端角标通过该时间记数
// ExpireTime int64  `bson:"etime" json:"etime"`           // 过期时间 单位毫秒
// Status     string `bson:"status" json:"status"`         // 状态 空 - 默认申请状态 pass - 已通过
// UpdateTime int64  `bson:"utime" json:"utime,omitempty"` // 记录更新的时间
// CreateTime int64  `bson:"ctime" json:"ctime"`           // 记录创建的时间
export interface FriendRquestSchema {
    id: string;
    touid: number;
    applyUid: number;
    hello: string;
    scene: string;
    applyTime: number;
    etime: number;
    status: string; // 空 - 默认申请状态 pass - 已通过 refuse -拒绝
    utime: number;
    ctime: number;
}

// export const COLLEAGUE_LIST = 'ColleagueList';
// export type COLLEAGUE_LIST = typeof COLLEAGUE_LIST;
// export const ColleagueList = {
//   name: COLLEAGUE_LIST,
//   properties: {
//     uid: 'string',
//     name: 'string',
//     avatar: 'string',
//     remark: 'string',
//     source: NewFriendSouce,
//     companyName: 'string',
//     positionName: 'string',
//     plat: 'string', // 'B', 'F', 'P'
//   },
//   primaryKey: 'uid',
// };

// 通讯录--群聊
// TopicId      string         `json:"tid"`           // 会话Id
// UserId       int64          `json:"uid"`           // 群聊就是创建人userId 单聊就是关联的对方userId
// CreateTime   int64          `json:"ctime"`         // 会话创建时间
// Name         string         `json:"name"`          // 会话名称
// namePY       string         `json:"namePY"`        // 会话名称拼音 驼峰 例如HuiHuaMing
// namePYS      string         `json:"namePYS"`       // 会话名称拼音缩减 只保留首字母 例如HHM
// Tag          string         `json:"tag"`           // 供应商群， 服务商群，供应链群，内部群（展示四字的公司名称）
// MemberAvatar []MemberAvatar `json:"memberAvatars"` // 图标 最开始9个人
export interface GroupChatSchema {
    tid: string;
    uid: number;
    ctime?: number;
    name?: string;
    namePY?: string;
    namePYS?: string;
    tag: string;
    memberAvatars: MEMBER_AVATARS[];
}

export const GROUP_CHAT_LIST = 'GroupChatList';
export type GROUP_CHAT_LIST = typeof GROUP_CHAT_LIST;
export const GroupChatList = {
    name: GROUP_CHAT_LIST,
    properties: {
        tid: 'string',
        uid: 'int',
        ctime: 'int?',
        name: 'string',
        namePY: 'string?',
        namePYS: 'string?',
        tag: 'string?',
        avatar: 'string?',
        memberAvatars: {
            type: 'list',
            objectType: 'MemberAvatars',
        },
    },
    primaryKey: 'tid',
};

export interface GroupSendMsgSchema {
    tid: string;
    uid: number;
    time: number;
}

export const GROUP_SEND_MSG = 'GroupSendMsg';
export type GROUP_SEND_MSG = typeof GROUP_SEND_MSG;
export const GroupSendMsg = {
    name: GROUP_SEND_MSG,
    properties: {
        tid: 'string',
        uid: 'int',
        time: 'int',
    },
    primaryKey: 'tid',
};

// UserId  int64  `json:"uid,omitempty"`
// Name    string `json:"name,omitempty"`
// NamePY  string `json:"namePY,omitempty"`  // 会话名称拼音 驼峰 例如HuiHuaMing
// NamePYS string `json:"namePYS,omitempty"` // 会话名称拼音缩减 只保留首字母 例如HHM
// Avatar  string `json:"avatar,omitempty"`
export interface MemberAvatarsSchema {
    tid: string;
    uid?: number;
    name?: string;
    namePY?: string;
    namePYS?: string;
    avatar?: string;
}

export const MEMBER_AVATARS = 'MemberAvatars';
export type MEMBER_AVATARS = typeof MEMBER_AVATARS;
export const MemberAvatarList = {
    name: MEMBER_AVATARS,
    properties: {
        tid: 'string',
        uid: 'int?',
        name: 'string?',
        namePY: 'string?',
        namePYS: 'string?',
        avatar: 'string?',
    },
};
